import { createAction, props } from '@ngrx/store';
import { SummaryData } from './summary-sheet.model';

export const createSummaryReport = createAction('[Summary] Create Summary Report', props<{ upid: string; withMlsHistory: boolean }>());

export const summaryTaskSuccess = createAction(
    '[Summary] Summary Task Success',
    <T>(upid: string, taskKey: string, result: T) => ({ upid, taskKey, result })
);

export const summaryTaskFail = createAction(
    '[Summary] Summary Task Fail',
    (upid: string, taskKey: string, reason: string) => ({ upid, taskKey, reason })
);

export const summaryTaskLoading = createAction('[Summary] Summary Task Loading', (upid: string, taskKey: string) => ({ upid, taskKey }));

export const updateGoogleStreetViewImage = createAction('[Summary] Update google street view image', props<{ upid: string, url: string }>());

export const editableMode = createAction('[Summary] Editable mode', props<{ upid: string; enabled: boolean }>());

export const revertChanges = createAction('[Summary] Revert changes', props<{ upid: string }>());

export const editItem = createAction('[Summary] Edit item', props<{ upid: string; key: keyof SummaryData, newValue: string | boolean | number }>());

export const deleteItem = createAction('[Summary] Delete item', props<{ upid: string; key: keyof SummaryData }>());

export const editTitle = createAction('[Summary] Edit title', props<{ upid: string; title: string }>());

export const deleteSection = createAction('[Summary] Delete section', props<{ upid: string; key: keyof SummaryData }>());

export const deleteArrayItem = createAction('[Summary] Delete array item', props<{ upid: string; key: keyof SummaryData; index: number }>());
